import {createStore} from 'redux';
import {persistStore, persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // Defaults to localStorage for web

import rootReducer from '../store/rootReducer'; // Combined reducers including persisted reducer

// Configuration object for Redux Persist
const persistConfig = {
    key: 'root', // The key for the top-level persistence object in storage
    storage, // The storage engine to use (localStorage in this case)
};

// Create a persisted reducer using the root reducer and persist configuration
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create a Redux store with the persisted reducer
export const store = createStore(persistedReducer);

// Create a persistor to manage persistence-related operations
export const persistor = persistStore(store);

/**
 * Redux Store and Persistor Setup
 *
 * This module configures and exports the Redux store and persistor for use in the application.
 * It uses `redux-persist` to enable state persistence, allowing the Redux state to be saved
 * and rehydrated from `localStorage`.
 */